var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgToday = function SvgToday(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.055 12.88v2.065L.102 9.993l1.038-1.03 3.915 3.917Zm2.065 2.065H5.055l4.952 4.953 1.033-1.033-3.92-3.92Zm11.746-3.914 1.032-1.033L10.002.102 8.97 1.135l3.91 3.915h-2.363l-2.73-2.727-1.033 1.032 1.7 1.7H7.27v7.679h7.679v-1.188l1.7 1.7 1.033-1.032L14.95 9.48V7.117l3.916 3.914ZM5.57 4.533 4.54 5.566l1.108 1.108L6.679 5.64 5.57 4.533Zm8.788 8.788-1.029 1.032 1.108 1.108 1.032-1.034-1.11-1.106ZM3.356 6.75 2.323 7.783l2.732 2.731V8.448L3.356 6.749Zm8.196 8.196H9.486l2.731 2.732 1.034-1.033-1.699-1.699Z",
    fill: "currentColor"
  })));
};

export default SvgToday;